<template>
  <select :id=templateId>
    <slot></slot>
  </select>
</template>

<script>
import $ from 'jquery'
require('select2')

export default {
  name: 'select2',
  props: ['id', 'options', 'value', 'enable', 'multiple', 'ajax', 'minimumInputLength', 'placeholder'],
  data () {
    return {
      templateId: this.id
    }
  },
  mounted: function () {
    var vm = this
    var config = {
      multiple: this.multiple === undefined ? true : this.multiple,
      width: 'resolve'
    }
    if (this.ajax) {
      config.ajax = this.ajax
      if (this.minimumInputLength !== undefined) {
        config.minimumInputLength = this.minimumInputLength
      }
    } else {
      config.data = this.options
    }
    if (this.placeholder) {
      config.placeholder = this.placeholder
      config.allowClear = true
    }
    $(this.$el)
      // init select2
      .select2(config)
      .val(this.value)
      .trigger('change')
      // emit event on change.
      .on('change', function () {
        vm.$emit('input', this.value)
        vm.$emit('change')
      })
    // $(this.$el).select2('enable', this.enable)
    $('span.select2-selection').addClass('custom_select2')
    $('span.select2').css('width', '100%')
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      if (!this.ajax) {
        // update options only when not using remote AJAX
        $(this.$el).empty().select2({ data: options })
      }
    },
    ajax: function (ajax) {
      if (ajax) {
        $(this.$el).empty().select2(Object.assign({
          multiple: this.multiple === undefined ? true : this.multiple,
          width: 'resolve'
        }, ajax, this.placeholder ? { placeholder: this.placeholder, allowClear: true } : {}))
      }
    },
    enable: function (enable) {
      $(this.$el).select2('enable', enable)
    }
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  }
}
</script>

<style>
.custom_select2 {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none !important;
  border-right-style: none !important;
  border-left-style: none !important;
  color: #777;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// Select2.vue?73dc4734